import AuditHistoryMenu from './AuditHistoryMenu';
import TemplateView from './../../TemplateView';
import {AuditInfoRecord} from "./AuditInfoRecord";
import $ from "jquery";
import _ from "underscore";


export class AuditHistoryView extends TemplateView {
    constructor({
        extraClass = "",
        loadAuditRecordsCb = () => {},
        onHistoryClickCb = () => {},
    })
    {
        super()

        this.lastUpdateAuditAction = null;
        this.createAuditAction = null;
        this.extraClass = extraClass;
        this.callbacks = {
            loadAuditRecordsCb,
            onHistoryClickCb,
        }

        this.state = {
            allAuditHistoryLoaded: false,
        }

        this.onStatePropertyChanged('allAuditHistoryLoaded', allAuditHistoryLoaded => {
            this.auditHistoryMenu.setState({allAuditHistoryLoaded})
        })

    }

    templateHtml()
    {
        return "<div class='auditHistory'>" +
               " <div class='createRecord auditRecord'/>" +
               " <div class='updateRecord auditRecord'/>" +
               " <div class='viewMore'><%=viewLabel%></div>" +
               "</div>";
    }

    afterRender()
    {
        this.$createRecord = this.find('.createRecord');
        this.$updateRecord = this.find('.updateRecord');
        this.$viewMore = this.find('.viewMore');

        this.auditHistoryMenu = new AuditHistoryMenu($('body'), this.extraClass, this.callbacks.onHistoryClickCb).init();
        this.$viewMore.click(() => {
            this.trigger(AuditHistoryView.LoadAuditRecrodsEvent, {offset: 0});
            this.callbacks.loadAuditRecordsCb(AuditHistoryView.RECORD_LIMIT, 0)
            this.auditHistoryMenu.showAt(this.$viewMore, {right: 0});
        });
        this.auditHistoryMenu.scrollView.on("scrollToEnd", () => {
            this.trigger(AuditHistoryView.LoadAuditRecrodsEvent, {offset: this.getRecords().length})
            this.callbacks.loadAuditRecordsCb(AuditHistoryView.RECORD_LIMIT, this.getRecords().length)
        });
    }

    setDateFormat(dateFormat)
    {
        this.auditHistoryMenu.setDateFormat(dateFormat);
    }

    update()
    {
        this.$createRecord.empty();
        this.$updateRecord.empty();
        if (this.createAuditAction)
            new AuditInfoRecord(this.createAuditAction).init(this.$createRecord);
        const hasUpdateHistory = !_.isNull(this.lastUpdateAuditAction);
        if (hasUpdateHistory)
            new AuditInfoRecord(this.lastUpdateAuditAction).init(this.$updateRecord);
        this.$updateRecord.toggle(hasUpdateHistory);
        this.$viewMore.toggle(hasUpdateHistory);
    }

    messageKeys()
    {
        return {viewLabel: "audit.audit_history.view_more"}
    }

    addRecords(auditRecords, dependencies)
    {
        this.auditHistoryMenu.addItems(auditRecords, dependencies);
    }

    setRecords(auditRecords) {
        this.auditHistoryMenu.setItems(auditRecords)
    }

    getRecords()
    {
        return this.auditHistoryMenu.getItems()
    }

    setAuditActions(createAudit, lastUpdateAudit, auditRecords)
    {
        this.createAuditAction = createAudit
        this.lastUpdateAuditAction = lastUpdateAudit
        this.auditHistoryMenu.setItems(auditRecords)
        this.update()
        this.show()
    }

    setLastAuditAction(lastUpdateAudit) {
        this.lastUpdateAuditAction = lastUpdateAudit
        this.update()
        this.show()
    }
}

AuditHistoryView.LoadAuditRecrodsEvent = "loadAuditRecords"
AuditHistoryView.RECORD_LIMIT = 5;

export default AuditHistoryView


// WEBPACK FOOTER //
// ./web/js/panels/auditHsitory/AuditHistoryView.js